(function () {
  'use strict';
  if (window.__fwMenuReady) return;
  window.__fwMenuReady = true;

  var PAGE = 8;
  var desktop = window.matchMedia('(min-width: 1041px)');
  var lastPointer = 'mouse';

  function tokens(card) {
    return ' ' + (card.getAttribute('data-fw-g') || '') + ' ';
  }

  function matches(card, filter) {
    if (!filter || filter === '*') return true;
    return filter.split(' ').some(function (token) {
      return token && tokens(card).indexOf(' ' + token + ' ') !== -1;
    });
  }

  function setupPanel(item) {
    var panel = item.querySelector('[data-fw-panel]');
    if (!panel) return null;
    var rail = panel.querySelector('[data-fw-rail]');
    var prev = panel.querySelector('[data-fw-prev]');
    var next = panel.querySelector('[data-fw-next]');
    var eyebrow = panel.querySelector('[data-fw-head-eyebrow]');
    var heading = panel.querySelector('[data-fw-head-title]');
    var cta = panel.querySelector('[data-fw-head-cta]');
    var links = Array.prototype.slice.call(item.querySelectorAll('[data-fw-filter]'));
    if (!rail) return null;

    var cards = Array.prototype.slice.call(rail.querySelectorAll('[data-fw-h]'));
    cards.forEach(function (card, index) { card.__fwIndex = index; });
    cards.sort(function (a, b) {
      var rankA = parseInt(a.getAttribute('data-fw-rank'), 10);
      var rankB = parseInt(b.getAttribute('data-fw-rank'), 10);
      if (isNaN(rankA)) rankA = 99;
      if (isNaN(rankB)) rankB = 99;
      return rankA - rankB || a.__fwIndex - b.__fwIndex;
    });
    cards.forEach(function (card) { rail.appendChild(card); });

    links.forEach(function (link) {
      if (!link.hasAttribute('data-fw-auto')) return;
      var filter = link.getAttribute('data-fw-filter');
      var count = cards.filter(function (card) { return matches(card, filter); }).length;
      link.hidden = !(count > 0 && count < cards.length);
    });

    var initial = {
      eyebrow: eyebrow ? eyebrow.textContent : '',
      heading: heading ? heading.textContent : '',
      href: cta ? cta.getAttribute('href') : '',
      cta: cta ? cta.textContent : ''
    };
    var defaultFilter = panel.getAttribute('data-fw-default') || '*';
    var list = [];
    var page = 0;
    var hoverTimer = 0;

    function draw() {
      var start = page * PAGE;
      cards.forEach(function (card) { card.hidden = true; });
      list.slice(start, start + PAGE).forEach(function (card) { card.hidden = false; });
      var pages = Math.ceil(list.length / PAGE);
      var paged = pages > 1;
      if (prev) {
        prev.hidden = !paged;
        prev.setAttribute('aria-disabled', String(page === 0));
      }
      if (next) {
        next.hidden = !paged;
        next.setAttribute('aria-disabled', String(page >= pages - 1));
      }
    }

    function show(filter) {
      list = cards.filter(function (card) { return matches(card, filter); });
      page = 0;
      draw();
    }

    function markActive(active) {
      links.forEach(function (link) {
        var on = link === active;
        link.classList.toggle('is-preview-active', on);
        if (link.tagName === 'BUTTON') link.setAttribute('aria-pressed', String(on));
      });
    }

    function activate(link) {
      var label = link.querySelector('strong');
      var detail = link.querySelector('span');
      markActive(link);
      if (eyebrow) eyebrow.textContent = label ? label.textContent.trim() : initial.eyebrow;
      if (heading) heading.textContent = detail ? detail.textContent.trim() : initial.heading;
      if (cta) {
        if (link.tagName === 'A') {
          cta.setAttribute('href', link.getAttribute('href'));
        } else {
          cta.setAttribute('href', initial.href);
        }
        cta.textContent = initial.cta;
      }
      show(link.getAttribute('data-fw-filter'));
    }

    function reset() {
      window.clearTimeout(hoverTimer);
      var first = links.filter(function (link) {
        return link.getAttribute('data-fw-filter') === defaultFilter && !link.hidden;
      })[0];
      if (eyebrow) eyebrow.textContent = initial.eyebrow;
      if (heading) heading.textContent = initial.heading;
      if (cta) {
        cta.setAttribute('href', initial.href);
        cta.textContent = initial.cta;
      }
      markActive(item.hasAttribute('data-fw-mark-default') ? first : null);
      show(defaultFilter);
    }

    if (prev) prev.addEventListener('click', function () {
      if (page === 0) return;
      page -= 1;
      draw();
    });
    if (next) next.addEventListener('click', function () {
      if ((page + 1) * PAGE >= list.length) return;
      page += 1;
      draw();
    });

    links.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        if (!desktop.matches) return;
        window.clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(function () { activate(link); }, 90);
      });
      link.addEventListener('mouseleave', function () { window.clearTimeout(hoverTimer); });
      link.addEventListener('focus', function () { activate(link); });
      if (link.tagName === 'BUTTON') {
        link.addEventListener('click', function () { activate(link); });
      }
    });

    reset();
    return reset;
  }

  function init() {
    var nav = document.querySelector('[data-fw-menu-nav]');
    if (!nav) return;
    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-fw-mega]'));
    var resets = new Map();

    function closeItem(item, focusSummary) {
      if (!item.hasAttribute('open')) return;
      item.removeAttribute('open');
      if (focusSummary) {
        var summary = item.querySelector(':scope > summary');
        if (summary) summary.focus({ preventScroll: true });
      }
    }

    function closeAll(except) {
      items.forEach(function (item) { if (item !== except) closeItem(item, false); });
    }

    items.forEach(function (item) {
      var summary = item.querySelector(':scope > summary');
      var openTimer = 0;
      var closeTimer = 0;
      resets.set(item, setupPanel(item));

      function openItem() {
        if (!desktop.matches) return;
        window.clearTimeout(openTimer);
        window.clearTimeout(closeTimer);
        closeAll(item);
        item.setAttribute('open', '');
      }

      item.addEventListener('toggle', function () {
        if (item.open) {
          closeAll(item);
        } else {
          var reset = resets.get(item);
          if (reset) reset();
        }
      });

      item.addEventListener('mouseenter', function (event) {
        if (!desktop.matches || event.pointerType === 'touch' || lastPointer === 'touch') return;
        window.clearTimeout(closeTimer);
        if (item.hasAttribute('open')) return;
        window.clearTimeout(openTimer);
        openTimer = window.setTimeout(openItem, 100);
      });

      item.addEventListener('mouseleave', function () {
        if (!desktop.matches || lastPointer === 'touch') return;
        window.clearTimeout(openTimer);
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () { closeItem(item, false); }, 180);
      });

      if (summary) {
        summary.addEventListener('click', function (event) {
          if (!desktop.matches) return;
          if (lastPointer === 'mouse' && event.detail > 0 && item.hasAttribute('open')) {
            event.preventDefault();
          }
        });
      }

      item.addEventListener('focusout', function (event) {
        if (!desktop.matches) return;
        if (event.relatedTarget && item.contains(event.relatedTarget)) return;
        if (!event.relatedTarget && item.matches(':hover')) return;
        closeItem(item, false);
      });
    });

    document.addEventListener('pointerdown', function (event) {
      lastPointer = event.pointerType || 'mouse';
      items.forEach(function (item) {
        if (item.hasAttribute('open') && !item.contains(event.target)) closeItem(item, false);
      });
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      items.forEach(function (item) {
        if (item.hasAttribute('open')) closeItem(item, true);
      });
    });

    function onBreakpoint() {
      if (!desktop.matches) closeAll(null);
    }
    if (desktop.addEventListener) desktop.addEventListener('change', onBreakpoint);
    else if (desktop.addListener) desktop.addListener(onBreakpoint);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
